import { COLOR_APP_TEXT } from "./theme";
import styled from "@emotion/styled";
import { ParagraphHeader } from "./typography/Paragraph";
import { COLOR_TERTIARY } from "./theme";

const AvatarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${COLOR_APP_TEXT};
  overflow: hidden; // Add this to clip the image
`;

const AvatarImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
`;

const Avatar = ({
  initials,
  photoUrl,
}: {
  initials?: string;
  photoUrl?: string;
}) => {
  if (initials) {
    return (
      <AvatarContainer>
        <ParagraphHeader
          color={COLOR_TERTIARY}
          fontWeight={700}
          marginTop="1px"
        >
          {initials}
        </ParagraphHeader>
      </AvatarContainer>
    );
  }

  if (photoUrl) {
    return (
      <AvatarContainer>
        <AvatarImage src={photoUrl} alt="Avatar" />
      </AvatarContainer>
    );
  }

  return null;
};

export default Avatar;
